import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=6fc021e0&scoped=true&"
import script from "./documents.js?vue&type=script&lang=js&"
export * from "./documents.js?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&id=6fc021e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc021e0",
  null
  
)

export default component.exports